import type { ReactNode } from 'react';
import { maskActivityCode, unmaskActivityCode } from '@/shared/lib/activity-code';
import { MaskedInput, type MaskedInputProps } from './masked-input';

/** Campo de CNAE com máscara `0000-0/00`; entrega só os dígitos. */
export function ActivityCodeInput({
  placeholder = '0000-0/00',
  ...props
}: MaskedInputProps): ReactNode {
  return (
    <MaskedInput
      inputMode="numeric"
      {...props}
      placeholder={placeholder}
      mask={maskActivityCode}
      unmask={unmaskActivityCode}
    />
  );
}
